/* tslint:disable */
/* eslint-disable */
/**
 * back-office-service
 * Back Office Service
 *
 * The version of the OpenAPI document: 0.29.35
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CustomerModuleView } from './CustomerModuleView';
import {
    CustomerModuleViewFromJSON,
    CustomerModuleViewFromJSONTyped,
    CustomerModuleViewToJSON,
} from './CustomerModuleView';

/**
 * 
 * @export
 * @interface CustomerModuleList
 */
export interface CustomerModuleList {
    /**
     * 
     * @type {Array<CustomerModuleView>}
     * @memberof CustomerModuleList
     */
    items: Array<CustomerModuleView>;
}

/**
 * Check if a given object implements the CustomerModuleList interface.
 */
export function instanceOfCustomerModuleList(value: object): value is CustomerModuleList {
    if (!('items' in value) || value['items'] === undefined) return false;
    return true;
}

export function CustomerModuleListFromJSON(json: any): CustomerModuleList {
    return CustomerModuleListFromJSONTyped(json, false);
}

export function CustomerModuleListFromJSONTyped(json: any, ignoreDiscriminator: boolean): CustomerModuleList {
    if (json == null) {
        return json;
    }
    return {
        
        'items': ((json['items'] as Array<any>).map(CustomerModuleViewFromJSON)),
    };
}

export function CustomerModuleListToJSON(value?: CustomerModuleList | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'items': ((value['items'] as Array<any>).map(CustomerModuleViewToJSON)),
    };
}

